module.exports = __webpack_public_path__ + "assets/media/lunch.fbd73b74.mp3";